// Simple hash-based router
import { isDirty, confirmIfDirty, markClean } from './utils/dirty-tracker.js';

const routes = {};
let currentRoute = '';
let currentHash = '';
let notFoundHandler = null;

export function route(path, handler) {
  routes[path] = handler;
}

export function onNotFound(handler) {
  notFoundHandler = handler;
}

export async function navigate(path) {
  if (isDirty()) {
    const ok = await confirmIfDirty('navigate away');
    if (!ok) return;
  }
  window.location.hash = '#' + path;
}

export function getCurrentRoute() {
  return currentRoute;
}

export function handleRoute() {
  // Strip any ?query=… off the hash before splitting on '/' so deep
  // links like #/library?diagnosis=ADHD resolve to the /library
  // handler. Pages that care about the query can read it back from
  // window.location.hash themselves.
  const rawHash = window.location.hash.slice(1) || '/';
  const qIdx = rawHash.indexOf('?');
  const hash = qIdx === -1 ? rawHash : rawHash.slice(0, qIdx);
  const [path, ...params] = hash.split('/').filter(Boolean);
  const routePath = '/' + (path || '');
  currentRoute = routePath;
  currentHash = window.location.hash;

  const handler = routes[routePath];
  if (handler) {
    handler(params);
  } else if (notFoundHandler) {
    notFoundHandler(routePath);
  } else if (routePath !== '/records') {
    // Unknown hash (mistyped link, stale bookmark): land on Records instead
    // of silently keeping the previous page under a wrong URL.
    window.location.hash = '#/records';
  }
}

async function onHashChange() {
  // Guard against navigating away with unsaved changes
  if (isDirty() && window.location.hash !== currentHash) {
    const ok = await confirmIfDirty('navigate away');
    if (!ok) {
      // Revert hash without firing handler
      window.removeEventListener('hashchange', onHashChange);
      window.location.hash = currentHash;
      setTimeout(() => window.addEventListener('hashchange', onHashChange), 0);
      return;
    }
    markClean();
  }
  handleRoute();
}

export function initRouter() {
  window.addEventListener('hashchange', onHashChange);
  handleRoute();
}
